import api from './../api'
import { decrypt, decryptAttachment, encrypt } from '../../pages/private/patients/helper'

export default {
  namespaced: true,
  state: {
    item: {},
  },

  getters: {},
  actions: {
    list(store, params) {
      return new Promise((resolve, reject) => {
        api.post('applications/list', params).then(response => {
          const { data } = response;
          let loggedUser = store.rootGetters['account/userStore'].getLoggedUser();
          data.items = data.items.map(application => ({
            ...application,
            patient: decrypt(store,loggedUser,application.patient),
          }));
          resolve(data);
        }).catch(error => {
          reject(error.response);
        });
      });
    },
    get(store, id) {
      return new Promise((resolve, reject) => {
        api.get('applications/' + id).then(response => {
          const { data } = response;
          let loggedUser = store.rootGetters['account/userStore'].getLoggedUser();
          data.patient = decrypt(store,loggedUser,data.patient)
          data.applicationsAttachments = data.applicationsAttachments.map(attachment => decryptAttachment(store,loggedUser,attachment));
          store.commit('setItem', data);
          resolve();
        }).catch(error => {
          reject(error.response);
        });
      });
    },
    attachments(store, id) {
      api.get('applications/attachments/' + id).then(response => {
        let loggedUser = store.rootGetters['account/userStore'].getLoggedUser();
        store.state.item.applicationsAttachments = response.data.map(attachment => decryptAttachment(store,loggedUser,attachment));
      }).catch(() => {});
    },
    remove(store, id) {
      return new Promise((resolve, reject) => {
        api.delete('applications/' + id).then(() => {
          store.dispatch('alert/success', 'Application was deleted', {root: true});
          resolve();
        }).catch(error => {
          store.dispatch('alert/warning', 'Application was not deleted', {root: true});
          reject(error.response);
        });
      });
    },
    create(store, params) {
      return new Promise((resolve, reject) => {
        api.post('applications', params).then(response => {
          if(typeof response.data === 'object') {
            const { data } = response
            let loggedUser = store.rootGetters['account/userStore'].getLoggedUser();
            data.patient = decrypt(store,loggedUser,data.patient)
            store.commit('setItem', data);
            store.dispatch('alert/success', 'Application was created as draft', {root: true});
            resolve(data);
          }
          else {
            store.dispatch('alert/danger', 'Application was NOT created', {root: true});
            reject(response);
          }
        }).catch(error => {
          reject(error.response);
          store.dispatch('alert/danger', 'Application was NOT created', {root: true});
        });
      });
    },
    sendApplication(store, id) {
      return new Promise((resolve, reject) => {
        api.post('applications/send/' + id, {}).then(response => {
          store.dispatch('alert/success', 'Application was sent to insurance', {root: true});
          resolve(response.data);
        }).catch(error => {
          reject(error.response);
          store.dispatch('alert/danger', 'Application was not sent to insurance', {root: true});
        });
      });
    },
    update(store, application) {
      return new Promise((resolve, reject) => {
        let applicationCopy = JSON.parse(JSON.stringify(application));
        let loggedUser = store.rootGetters['account/userStore'].getLoggedUser();
        applicationCopy.patient = encrypt(store,loggedUser,applicationCopy.patient)
        api.put('applications/' + applicationCopy.id, applicationCopy).then(response => {
          if(typeof response.data === 'object') {
            const { data } = response
            data.patient = decrypt(store,loggedUser,data.patient)
            store.commit('setItem', data);
            store.dispatch('alert/success', 'Application was updated', {root: true});
            resolve(data);
          }
          else {
            store.dispatch('alert/error', 'Application NOT updated', {root: true});
            resolve(false);
          }
        }).catch(error => {
          let msg = error && error.data && error.data.status ? error.data.status : 'Application NOT updated';
          store.dispatch('alert/warning', msg);
          reject(error.response);
        });
      });
    },
    setState(store, params) {
      return new Promise((resolve, reject) => {
        api.put('applications/set-state/' + params.id + '/' + params.stateId, params).then(response => {
          store.dispatch('alert/success', 'Application status was updated', {root: true});
          resolve(response.data);
        }).catch(error => {
          store.dispatch('alert/warning', error.data.status);
          reject(error.response);
        });
      });
    },
    uploadSigned(store, params) {
      return new Promise((resolve, reject) => {
        api.post('applications/upload-signed/', params).then(response => {
          resolve(response.data);
        }).catch(error => {
          reject(error.response);
        });
      });
    },
    removeSigned(store, hash) {
      return new Promise((resolve, reject) => {
        api.post('applications/remove-signed-document/' + hash).then(response => {
          resolve(response.data);
        }).catch(error => {
          reject(error.response);
        })
      })
    },
    export(store, params) {
      return new Promise((resolve, reject) => {
        api.post(`applications/export-new`, params).then(response => {
          resolve(response.data);
        }).catch(error => {
          reject(error.response.data);
        })
      })
    },
  },
  mutations: {
    setItem(state, data) {
      state.item = data;
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/applications.js